import FlexColumn from "designSystem/components/flex/FlexColumn";
import FlexRowCenter from "designSystem/components/flex/FlexRowCenter";
import RequestErrorPlaceholder, { RequestErrorPlaceholderProps } from "designSystem/components/placeholder/RequestErrorPlaceholder";
import React, { FunctionComponent } from "react";
import { FallbackProps } from "react-error-boundary";
import { MSTeamsApiError } from "../msteams/api";
import { SlackApiError } from "../slack/api";
import JoinSlack from "../slack/component/JoinSlack";

/**
 * Error fallback widget to use with {@link https://github.com/bvaughn/react-error-boundary|react-error-boundary}.
 *
 * It tries to display some meaningful message if Slack API returned with 'ok' flag set to 'false'.
 *
 * If the error is not from Slack API, it displays the generic error message
 */
export const ErrorFallback: FunctionComponent<FallbackProps> = ({ error, resetErrorBoundary }) => {
	if (error instanceof SlackApiError) {
		const { apiResponse } = error;
		switch (apiResponse.error) {
			case "not_authed":
			case "invalid_auth":
			case "account_inactive":
			case "token_revoked":
			case "no_permission":
			case "not_allowed_token_type":
			case "missing_scope":
				return (<JoinSlack />);

			case "channel_not_found":
				return (
					<ErrorPanel
						onRetry={resetErrorBoundary}
						subtitleRes="SlackChannelNotFound_Description"
						titleRes="SlackChannelNotFound"
					/>
				);

			default:
				return (<ErrorPanel onRetry={resetErrorBoundary} />);
		}
	} else if (error instanceof MSTeamsApiError) {
		// need to refine this after PM review
		return (
			<ErrorPanel
				onRetry={resetErrorBoundary}
				subtitleRes="MSTeamsErrorDescription"
				subtitleResParams={[error.apiResponse?.ErrorAdmin]}
			/>
		);
	} else {
		return (<ErrorPanel onRetry={resetErrorBoundary} />);
	}
};

const ErrorPanel: FunctionComponent<RequestErrorPlaceholderProps> = (props) => {
	return (
		<FlexColumn>
			<FlexRowCenter
				flexGrow={1}
				justifyContent="center"
				px={3}
			>
				<RequestErrorPlaceholder {...props} />
			</FlexRowCenter>
		</FlexColumn>
	);
};